import $ from 'jquery';
import objectFitImages from 'object-fit-images';

$(function() {
    objectFitImages();
});
